import React, { Component, Fragment } from 'react';
import Wrapper from './../../../common/component/Wrapper';
import * as Func from '../../../../../helpers/functions';
import { Link } from 'react-router-dom';
import { DATE_TIME_FORMAT, PATHS, TICKET } from '../../../../../constants/Define';
import { FormWrapperItem, ListComponent, StatusComponent, FilterDropdown } from '../../../common/component/Index';
import Modal from '../../../common/component/Modal';
import Ripple from '../../../common/component/Ripple';
import Dropdown from '../../../common/component/Dropdown';
import { FlagIcons } from '../../../common/component/TranslateButton';

import Ticket from '../../../../../models/Ticket';
import { Icon, Menu, Popover } from 'antd';
import { isEqual, find, toArray } from 'lodash';
import './TicketList.less';
import Span from '../../../common/component/Span';
import { getLocaleFullName } from '../../../../../utils/commonUtils';

const defaultState = {

};

const ListCols = [
    'ticketName', 'actionType', 'priority', 'status',
    'orderCode', 'contactName', 'assigner', 'assignee',
    'product', 'createdDate', 'openedTime', 'closedTime'
];
const ModelFields = Object.getOwnPropertyNames(new Ticket());

export default class TicketList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                ticketName: {
                    sorter: (i, k) => (i.ticketName || '').length - k.length,
                    fixed: 'left',
                    width: 200,
                },
                actionType: {
                    key: 'actionType',
                    render: (text, record) => {
                        const typeEnum = find(toArray(TICKET.ACTION_TYPE), item => item.id === record.actionType)
                        return !!typeEnum && <Span>{this.props.t(`item.ticket.actionTypes.${typeEnum.key}`)}</Span>
                    }
                },
                priority: {
                    key: 'priority',
                    render: (text, record) => {
                        const priorityEnum = find(toArray(TICKET.PRIORITY), item => item.id === record.priority)
                        return !!priorityEnum && <Span>{this.props.t(`item.ticket.priorities.${priorityEnum.key}`)}</Span>
                    }
                },
                orderCode: {
                    key: '',
                    width: 200,
                    render: (text, record) => (
                        <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                            <Span>{record.orderCode}</Span>
                        </Link>
                    )
                },
                status: {
                    key: 'status',
                    render: (text, record) => {
                        const statusEnum = find(toArray(TICKET.STATUS), item => item.id === record.status)
                        return !!statusEnum && <StatusComponent color={statusEnum.color}
                            label={this.props.t(`item.ticket.statusTypes.${statusEnum.key}`)} />
                    }
                },
                contactName: {
                    key: 'contactName',
                    render: (text, record) => {
                        const contactName = getLocaleFullName(record.contactFirstName, record.contactLastName);
                        return <Popover
                            title={this.props.t(`item.ticket.contactInfo`)}
                            content={
                                <Wrapper style={{ display: 'flex', flexDirection: 'column' }}>
                                    {!!record.contactEmail && <Span className="w100-percent">{this.props.t(`item.ticket.contactEmail`)}: {record.contactEmail}</Span>}
                                    {!!record.contactPhone && <Span className="w100-percent">{this.props.t(`item.ticket.contactPhone`)}: {record.contactPhone}</Span>}
                                </Wrapper>
                            }>
                            <Span className="w100-percent">{contactName}</Span>
                        </Popover>
                    }
                },
                assigner: {
                    key: 'assignerName',
                    render: (text, record) => record.assignerName,
                },
                assignee: {
                    key: 'assigneeName',
                    render: (text, record) => record.assigneeName,
                },
                product: {
                    render: (text, record) => this.renderProductInfo(record.ticketData || {}),
                },
                createdDate: {
                    sorter: (i, k) => (i.createdDate || '').length - k.length,
                    render: (text, record) => record.createdDate && record.createdDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                openedTime: {
                    sorter: (i, k) => (i.openedTime || '').length - k.length,
                    render: (text, record) => record.openedTime && record.openedTime.format(DATE_TIME_FORMAT.DATE_TIME),
                },
                closedTime: {
                    sorter: (i, k) => (i.closedTime || '').length - k.length,
                    render: (text, record) => record.closedTime && record.closedTime.format(DATE_TIME_FORMAT.DATE_TIME),
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    fixed: 'right',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
        };
    }

    render() {
        const { t, tickets, loading, pagination } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <Wrapper className="mt-2 redeemtion-list">
                <ListComponent
                    tableKey="ticket-list"
                    scroll={{ x: 1800 }}
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(tickets || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'ticket'
                    })}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.pageIndex, pageSize: pagination.pageSize }}
                    onChange={this.props.onChange}
                    componentTableList={{}}
                />
            </Wrapper>
        );
    }

    renderEditComponent(item) {
        const { permissions } = this.props;

        return (
            // permissions && permissions.allowUpdate &&
            <Link to={Func.getPathWithParams(PATHS.TICKET.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                <Icon type="form" className="fs20 mr-1" />
            </Link>
        )
    }

    renderProductInfo(ticketData = {}) {
        return null
    }

}

TicketList.defaultProps = {
    tickets: [],
    pagination: {},
    permissions: {},
    loading: false,
    onChange: (pagination, filters, sorter) => { },
}

